import React from 'react'
import { ApolloProvider, useQuery } from '@apollo/client/react'
import { CustomFormats, IntlProvider } from 'react-intl'
import { BrowserRouter } from 'react-router-dom'
import { App } from './App'
import { createGraphqlClient, IS_AUTHENTICATED_QUERY } from '../../graphql-client/graphql-client'
import localeData from '../../translations/fi.json'
import { StoreProvider } from '../StoreProvider'
import { handleEnvironmentSettings } from '../../util/environment'
import { SocketContext, socket } from '../SocketProvider'
import { useLoadScripts } from '../../util/useGoogle'
import { GlobalStyle } from '../../styled'
import { ErrorFallback } from './ErrorFallback'
import { loadErrorMessages, loadDevMessages } from "@apollo/client/dev";
import { ErrorBoundary } from '../../components/ErrorBoundary'

// Override methods for different environments
handleEnvironmentSettings()

const language = 'fi'

interface QueryData {
  authenticated: boolean
}

const apolloClient = createGraphqlClient()

if (process.env.NODE_ENV === 'development' ) {
    loadDevMessages();
    loadErrorMessages();
}
// react-intl v5+ formats
const dateAndTimeFormats: CustomFormats = {
  date: {
    full: {
      weekday: 'short',
      day: 'numeric',
      month: 'numeric',
      year: 'numeric',
    },
  },
}

const AppWithAuth: React.FC = () => {
  const { data } = useQuery<QueryData>(IS_AUTHENTICATED_QUERY)
  const authenticated = data?.authenticated ?? false

  return (
    <SocketContext.Provider value={socket}>
      <StoreProvider>
        <BrowserRouter>
          <GlobalStyle />
          <App authenticated={authenticated} />
        </BrowserRouter>
      </StoreProvider>
    </SocketContext.Provider>
  )
}

export const AppContainer: React.FC = () => {
  useLoadScripts()

  return (
    <ErrorBoundary fallback={ErrorFallback}>
      <IntlProvider locale={language} defaultLocale="fi" messages={localeData} formats={dateAndTimeFormats}>
        <ApolloProvider client={apolloClient}>
          <AppWithAuth />
        </ApolloProvider>
      </IntlProvider>
    </ErrorBoundary>
  )
}

